// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var m = require('mobx');
  const { ceil, omitBy, isEmpty } = require('lodash/fp');

  var DEFAULT_PAGE_SIZE = 10;
  var SEARCH_OPERATION = {
    EQUALS: 0,
    LIKE: 1
  };

  var SORT_DESC = 'DESC';

  /**
   * @param {object} colSortDirs
   * @param {string} searchProperty
   * @param {string} searchText
   * @returns {Paging} object
   */
  function Paging(colSortDirs, searchProperty, searchText) {
    /* for request object to backend only */
    this.sortOrders = [];
    this.searchCriteria = [];

    m.extendObservable(this, {
      pageIndex: 1, // for paging
      pageSize: DEFAULT_PAGE_SIZE, // for paging, only change when user change page size dropdown
      colSortDirs: colSortDirs, // for sorting in UI only
      searchProperty: searchProperty || '', // for searching in UI only
      searchText: searchText || '', // for searching in UI only
      totalRecords: 0,
      totalPage: 0
    });
  }

  Paging.prototype.setPageIndex = m.action(function(pageIndex) {
    this.pageIndex = pageIndex;
  });

  Paging.prototype.setPageSize = m.action(function(pageSize) {
    this.pageSize = pageSize;
    this.totalPage = ceil(this.totalRecords / this.pageSize) || 1;
  });

  Paging.prototype.setTotalRecords = m.action(function(totalRecords) {
    this.totalRecords = totalRecords;
    this.totalPage = ceil(totalRecords / this.pageSize) || 1;
  });

  Paging.prototype.increaseRecord = m.action(function() {
    this.totalRecords++;
  });

  Paging.prototype.descreaseRecord = m.action(function() {
    this.totalRecords && this.totalRecords--;
  });

  Paging.prototype.setColSortDirs = m.action(function(key, value) {
    this.colSortDirs[key] = value;
    this.colSortDirs = omitBy(isEmpty, this.colSortDirs);
  });

  /* For searching */
  Paging.prototype.setSearchValues = m.action(function(searchProperty, searchText) {
    this.searchProperty = searchProperty;
    this.searchText = searchText;
  });

  /**
   * Wrapping Paging object for matching Paging object from backend
   * Sample output Paging object:
   *  {number} pageIndex
   *  {number} pageSize
   *  {array} sortOrders -> sample [{key: 'colName', descending: boolean }]
   *  {array} searchCriteria -> sample [{key: 'colName', value: string, operation: EQUALS || LIKE }]
   */
  Paging.prototype.buildPagingRequest = m.action(function() {
    this.buildSortOrder();
    this.buildSearchCriteria();
  });

  /**
   * Build sortOrders request object to backend
   * Sample format -> sample [{key: 'colName', descending: boolean }]
   */
  Paging.prototype.buildSortOrder = m.action(function() {
    var newOrders = [];

    for (var col in this.colSortDirs) {
      if (!isEmpty(this.colSortDirs[col])) {
        newOrders.push({
          key: col,
          descending: isDescending(this.colSortDirs[col])
        });
      }
    }
    this.sortOrders = newOrders;
    return this.sortOrders;
  });

  /**
   * Build searchCriteria request object to backend
   * Sample format -> [{key: 'colName', value: string, operation: EQUALS || LIKE }]
   */
  Paging.prototype.buildSearchCriteria = m.action(function() {
    this.searchCriteria = [
      {
        key: this.searchProperty,
        value: this.searchText,
        operation: SEARCH_OPERATION.LIKE
      }
    ];
  });

  function isDescending(sortDir) {
    if (sortDir && sortDir === SORT_DESC) {
      return true;
    }
    return false;
  }

  module.exports = Paging;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/DataGrid/helpers/Izenda.PagingModel.js